// "Ask about this" buttons open the Concierge with what is on screen:
// openConcierge('analysis', { title: 'Granite Coffee', statement_id, facts: ['3 months grouped'] })
export const CONCIERGE_OPEN_EVENT = 'rf:concierge-open';

export interface ConciergeOpenDetail {
	page: string;
	context?: {
		title?: string;
		statement_id?: string;
		facts?: string[];
		[key: string]: unknown;
	};
}

export const openConcierge = (
	page: string,
	context?: ConciergeOpenDetail['context'],
) =>
	window.dispatchEvent(
		new CustomEvent<ConciergeOpenDetail>(CONCIERGE_OPEN_EVENT, {
			detail: { page, context },
		}),
	);
